export default (queryString) => {
  const params = {};

  const search = queryString.replace(/^\?/, '');

  if (search) {
    const args = search.split('&');
    for (let i = 0; i < args.length; i += 1) {
      const key = args[i].split('=')[0];
      const value = args[i].split(`${key}=`)[1];

      if (key) {
        try {
          params[key] = decodeURIComponent(value || '');
          /* istanbul ignore next */
        } catch (e) {
          params[key] = value || '';
        }
      }
    }
  }

  return params;
};
